/**
 * Color tokens extracted from Stitch design
 * Used by: Expo app, Docusaurus docs, Website
 */

// Brand colors
export const brand = {
  // Pink/Magenta - primary brand color
  primary: '#c73c74',
  primaryLight: '#d85a8a',
  primaryDark: '#a82f5f',

  // Orange - secondary brand color
  secondary: '#e99d52',
  secondaryLight: '#f0b574',
  secondaryDark: '#d4863a',
} as const;

// Light mode colors
export const lightColors = {
  background: '#f6f8f7',
  surface: '#ffffff',
  surfaceHover: '#f9fafb',
  text: '#111814',
  textSecondary: '#637588',
  border: '#e5e7eb',
  primary: brand.primary,
  primaryText: '#ffffff',
  secondary: brand.secondary,
  secondaryText: '#111814',
} as const;

// Dark mode colors
export const darkColors = {
  background: '#102219',
  surface: '#1E2C24',
  surfaceHover: '#25362c',
  text: '#ffffff',
  textSecondary: '#a0acb7',
  border: '#2f3e35',
  primary: brand.primary,
  primaryText: '#ffffff',
  secondary: brand.secondary,
  secondaryText: '#111814',
} as const;

// Semantic colors (same for both themes)
export const semantic = {
  success: '#22c55e',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  neutral: '#9e9e9e',
} as const;

// Social provider colors
export const social = {
  google: '#4285F4',
  apple: '#000000',
  facebook: '#1877F2',
} as const;

// Common colors (not theme-specific)
export const common = {
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
} as const;

export type ThemeColors = typeof lightColors;
